module.exports = __webpack_public_path__ + "static/media/ScrollUpHoverButton.dd87e63f.svg";